var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewDimission"},[_c('el-row',{attrs:{"gutter":10}},[_c('OACard',{attrs:{"header":"基本信息","col":24}},[_c('form-component',{ref:"formData",attrs:{"form-data":_vm.formData,"label-width":"150px"}})],1),_vm._v(" "),_c('otherInfo',{attrs:{"userId":_vm.userId,"evaluate":false,"readonly":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb102cf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personnel/dimissionDetail.vue
// module id = null
// module chunks = 